import type {Theme} from "@mui/material/styles";
import theme from "../../theme";

/** AppBar + Toolbar */
export const appBarSx = (theme: Theme) => ({
    position: "sticky",
    backgroundColor: theme.palette.common.white,
} as const);

export const toolbarSx = {
    justifyContent: "space-between", alignItems: "center",
} as const;

/** Logo and Title Container */
export const logoAndTitleContainerSx = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    verticalAlign: "center",
    margin: theme.spacing(1),
    gap: theme.spacing(1.5),
    cursor: "pointer",
}

/** New Relic Toolbox Logo */
export const neRelicToolboxLogoSx = (theme: Theme) => ({
    height: theme.spacing(7),
} as const);

/** Title */
export const newRelicToolboxTitleSx = (theme: Theme) => ({
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: theme.spacing(3),
    textAlign: "center",
    lineHeight: 1
} as const);

/** Right side cluster */
export const profileBox = (theme: Theme) => ({
    display: "flex", alignItems: "center", gap: theme.spacing(1), height: "100%", cursor: "pointer",
} as const);

export const accountButtonSx = (theme: Theme) => ({
    textTransform: "capitalize",
    fontWeight: "bold",
})

export const welcomeTextSx = (theme: Theme) => ({
    color: "rgba(0, 0, 0, 0.6)",
})

export const helperLinkBox = (theme: Theme) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(1),
    "&:hover": {backgroundColor: theme.palette.action.hover},
} as const);

/** Icon */
export const helpIcon = {
    color: theme.palette.primary.main, fontSize: 37, marginTop: '10%',
};

export const accountMenuSx = (theme: Theme) => ({
    "& .MuiMenu-paper": { backgroundColor: theme.palette.primary.main , },
})